'use client';

import { resolveClassNames } from '../resolve-class-names/resolve-class-names.mjs';
function getOptionsClassNames(_ref) {
  var selector = _ref.selector,
    stylesCtx = _ref.stylesCtx,
    options = _ref.options,
    props = _ref.props,
    theme = _ref.theme;
  return resolveClassNames({
    theme: theme,
    classNames: options === null || options === void 0 ? void 0 : options.classNames,
    props: (options === null || options === void 0 ? void 0 : options.props) || props,
    stylesCtx: stylesCtx
  })[selector];
}
export { getOptionsClassNames };